import Vue from "vue";
// import md5 from "js-md5";
import router from "@/router";
import config from "@/config";
import errorTags from "@/errorTags";
import jwt from "jsonwebtoken";
import authority from "@/authority";
import authorityOpr from "@/authorityOpr";

export default {
  namespaced: true,
  state: {
    _loading: {
      login: false,
      logout: false,
      firstTime: false,
      security: false,
      updatePassword: false,
      getAgentDetail: false,
      getSubDetail: false,
      domainSetup: false
    },
    attachmentPath: "",
    sessionToken: "",
    accountId: "",
    loginId: "",
    username: "",
    password: "",
    authorityRole: "",
    accountType: "",
    securityTag: "",
    securityDisabled: true,
    account: [],
    // account_profile: [],
    account_authority: [],
    alertOn: true,
    daily_statement: {
      start_date: '',
      end_date: ''
    },
    win_lose: {
      start_date: '',
      end_date: ''
    },
    win_lose_member: {
      start_date: '',
      end_date: ''
    },
    daily_summary_company: {
      start_date: '',
      end_date: ''
    },
    daily_summary_operator: {
      operator_id: '',
      start_date: '',
      end_date: ''
    },
    daily_summary_member: {
      working_date: ''
    },
    report_statement: {
      start_date: '',
      end_date: '',
      operator_id: null,
      member_id: null,
      game_name: null,
      on_site: null,
      exclude_own: null
    },
    game_result: {
      account_id: '',
      start_date: '',
      end_date: '',
      rebate_type: null,
      provider: null,
      table_id: null,
      rescue_type: null
    },
    game_result_slots: {
      start_date: '',
      end_date: '',
      provider: null
    },
    game_result_livecasino: {
      start_date: '',
      end_date: '',
      provider: null,
      table_id: null,
    },
    game_result_sportsbook: {
      start_date: '',
      end_date: '',
      provider: null,
      search_created_date: false
    },
    game_result_cockfight: {
      start_date: '',
      end_date: '',
      provider: null
    },
    game_result_rescue: {
      start_date: '',
      end_date: '',
      game_type: null
    },
    game_result_reward: {
      start_date: '',
      end_date: ''
    },
    game_result_free_slots: {
      start_date: '',
      end_date: '',
      provider: null
    },
    game_result_others: {
      start_date: '',
      end_date: '',
      provider: null
    },
    rebate_member: {
      start_date: '',
      end_date: '',
      rebate_type: null
    },
    member_linkage: {
      linkage_type: null,
      full_linkage: false
    },
    bonus_list: {
      member_id: '',
      start_date: '',
      end_date: ''
    },
    adjustment_log: {
      start_date: '',
      end_date: '',
      signup_bonus: null,
      filter_amount: 1,
    },
    bonus_log: {
      start_date: '',
      end_date: '',
      manual_bonus: false
    },
    login_log: {
      start_date: '',
      end_date: '',
      login_ip: '',
      login_status: 99
    },
    result_changes_log: {
      start_date: '',
      end_date: ''
    },
    vip_log: {
      start_date: '',
      end_date: '',
      action_type: '',
      member_full_record: false
    },
    token_log: {
      start_date: '',
      end_date: '',
    },
    adjust_free_balance_log: {
      action_type: "",
      start_date: '',
      end_date: '',
    },
    member_wallet_voucher_log: {
      action_type: ""
    },
    member_voucher_redeemed_log: {
      start_date: '',
      end_date: ''
    },
    member_log: {
      start_date: '',
      end_date: '',
      action_type: ''
    },
    freespin_log: {
      start_date: '',
      end_date: '',
      action_type: '',
      provider_code: ''
    },
    adjustment_list: {
      member_id: '',
      start_date: '',
      end_date: ''
    },
    referee_list: {
      referral_code: ''
    },
    transfer_list: {
      target_account_id: '',
      date: '',
      search_id: '',
      request_type: ''
    },
    win_lose_aff: {
      month: null,
      search_id: ''
    },
    ticket_wallet_trans_list: {
      operator_id: '',
      member_id: '',
      working_date: '',
      request_type: ''
    },
    member_details: {
      member_id: ''
    },
    pending_ticket: {
      tab: ''
    },
    daily_winlose_sb_detail: {
      working_date: ''
    },
    daily_statement_aff: {
      account_id: '',
      start_date: '',
      end_date: ''
    },
    adjustment_list_aff: {
      account_id: '',
      start_date: '',
      end_date: ''
    },
    daily_summary_company_detail: {
      working_date: ''
    },
    daily_summary_operator_detail: {
      operator_id: '',
      working_date: ''
    },
    selectedMemberID: "",
    selectedOperatorID: "",
    selectedAffiliateID: "",
    selectedSiteID: "",
    selectedTheme: "",
    isShown: false,
    tacExpiry: 0,
    selectedNewWebsite: null,
    currencyCode: null,
    cpiDetails: null,
    authOriginalChecked: []
  },
  mutations: {
    update(state, payload) {
      state.account = payload.user.account;
      state.account_authority = payload.user.account_authority;
      // state.account_profile = payload.user.account_profile;
      state.sessionToken = payload.sessionToken;
      state.username = payload.loginId;
      state.loginId = payload.loginId;
      state.accountId = payload.user.account[0].account_id;
      state.authorityRole = payload.authorityRole;
      state.accountType = payload.user.account[0].account_type;
      state.securityTag = payload.user.account[0].security_tag;
      state.securityDisabled = payload.user.account[0].security_disabled;
      state.alertOn = true;
    },
    delete(state) {
      state.attachmentPath = "";
      state.sessionToken = "";
      state.accountId = "";
      state.loginId = "";
      state.username = "";
      state.password = "";
      state.authorityRole = "";
      state.alertOn = null;
      state.account = [];
      state.account_authority = [];
      state.accountType = "";
      state.securityTag = "";
      state.securityDisabled = true;
      // state.account_profile = [];
      state.daily_statement.account_id = "";
      state.daily_statement.start_date = "";
      state.daily_statement.end_date = "";
      state.win_lose.account_id = "";
      state.win_lose.start_date = "";
      state.win_lose.end_date = "";
      state.daily_summary_company.start_date = "";
      state.daily_summary_company.end_date = "";
      state.daily_summary_member.operator_id = "";
      state.daily_summary_operator.operator_id = "";
      state.daily_summary_operator.start_date = "";
      state.daily_summary_operator.end_date = "";
      state.daily_summary_member.working_date = "";
      state.bonus_list.member_id = "";
      state.bonus_list.start_date = "";
      state.bonus_list.end_date = "";
      state.adjustment_list.member_id = "";
      state.adjustment_list.start_date = "";
      state.adjustment_list.end_date = "";
      state.report_statement.start_date = "";
      state.report_statement.end_date = "";
      state.report_statement.operator_id = null;
      state.report_statement.member_id = null;
      state.report_statement.game_name = null;
      state.report_statement.on_site = null;
      state.report_statement.exclude_own = null;
      state.game_result.account_id = "";
      state.game_result.start_date = "";
      state.game_result.end_date = "";
      state.game_result.rebate_type = null;
      state.game_result.provider = null;
      state.game_result.table_id = null;
      state.game_result.rescue_type = null;
      state.game_result_slots.start_date = "";
      state.game_result_slots.end_date = "";
      state.game_result_slots.provider = null;
      state.game_result_livecasino.start_date = "";
      state.game_result_livecasino.end_date = "";
      state.game_result_livecasino.provider = null;
      state.game_result_livecasino.table_id = null;
      state.game_result_sportsbook.start_date = "";
      state.game_result_sportsbook.end_date = "";
      state.game_result_sportsbook.provider = null;
      state.game_result_sportsbook.search_created_date = false;
      state.game_result_cockfight.start_date = "";
      state.game_result_cockfight.end_date = "";
      state.game_result_cockfight.provider = null;
      state.game_result_rescue.start_date = "";
      state.game_result_rescue.end_date = "";
      state.game_result_rescue.game_type = null;
      state.game_result_reward.start_date = "";
      state.game_result_reward.end_date = "";
      state.game_result_free_slots.start_date = "";
      state.game_result_free_slots.end_date = "";
      state.game_result_free_slots.provider = null;
      state.game_result_others.start_date = "";
      state.game_result_others.end_date = "";
      state.game_result_others.provider = null;
      state.rebate_member.start_date = "";
      state.rebate_member.end_date = "";
      state.rebate_member.rebate_type = null;
      state.member_linkage.linkage_type = null;
      state.member_linkage.full_linkage = false;
      state.ticket_wallet_trans_list.working_date = "";
      state.ticket_wallet_trans_list.operator_id = "";
      state.ticket_wallet_trans_list.member_id = "";
      state.ticket_wallet_trans_list.request_type = "";
      state.member_details.member_id = "";
      state.pending_ticket.tab = "";
      state.daily_winlose_sb_detail.working_date = "";
      state.daily_statement_aff.account_id = "";
      state.daily_statement_aff.start_date = "";
      state.daily_statement_aff.end_date = "";
      state.adjustment_list_aff.account_id = "";
      state.adjustment_list_aff.start_date = "";
      state.adjustment_list_aff.end_date = "";
      state.adjustment_log.start_date = "";
      state.adjustment_log.end_date = "";
      state.adjustment_log.signup_bonus = null;
      state.adjustment_log.filter_amount = 1;
      state.bonus_log.start_date = "";
      state.bonus_log.end_date = "";
      state.bonus_log.manual_bonus = false;
      state.login_log.start_date = "";
      state.login_log.end_date = "";
      state.login_log.login_ip = "";
      state.login_log.login_status = 99;
      state.result_changes_log.start_date = "";
      state.result_changes_log.end_date = "";
      state.vip_log.start_date = "";
      state.vip_log.end_date = "";
      state.vip_log.action_type = "";
      state.vip_log.member_full_record = false;
      state.token_log.start_date = "";
      state.token_log.end_date = "";
      state.adjust_free_balance_log.action_type = "";
      state.member_wallet_voucher_log.action_type = "";
      state.member_log.start_date = "";
      state.member_log.end_date = "";
      state.member_log.action_type = "";
      state.freespin_log.start_date = "";
      state.freespin_log.end_date = "";
      state.freespin_log.action_type = "";
      state.freespin_log.provider_code = "";
      state.member_voucher_redeemed_log.start_date = "";
      state.member_voucher_redeemed_log.end_date = "";
      // state.transfer_list.target_account_id = "";
      // state.transfer_list.date = "";
      // state.transfer_list.search_id = "";
      // state.transfer_list.request_type = "";
      // state.bonus_and_adjustment.target_account_id = "";
      // state.bonus_and_adjustment.search_id = "";
      // state.bonus_and_adjustment.date = "";
      // state.win_lose_aff.month = null;
      // state.win_lose_aff.search_id = "";
      state.referee_list.referral_code = "";
      state.daily_summary_company_detail.working_date = "";
      state.daily_summary_operator_detail.working_date = "";
      state.selectedMemberID = "";
      state.selectedOperatorID = "";
      state.selectedAffiliateID = "";
      state.selectedSiteID = "";
      state.selectedTheme = "";
      state.isShown = false;
      state.tacExpiry = 0;
      state.selectedNewWebsite = null;
      state.currencyCode = null
      state.cpiDetails = null
      state.authOriginalChecked = []
    },
    updateTACExpiry(state, payload){
      state.tacExpiry = payload
    },
    updateGuide(state, payload) {
      state.isShown = payload;
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    },
    updateAlertOn(state, payload) {
      state.alertOn = payload;
    },
    updateSecurity(state, payload) {
      state.account[0].security_tag = payload.security_tag;
      state.account[0].security_disabled = payload.security_disabled;
    },
    updateAccountSetup(state, payload) {
      state.account[0].min_deposit = payload.min_deposit;
      state.account[0].min_withdrawal = payload.min_withdrawal;
      state.account[0].min_balance = payload.min_balance;
    },
    updateAccountAuthorityOption(state, payload) {
      state.account_authority[0].authority_option = payload;
    },
    updateAttachmentPath(state, payload) {
      state.attachmentPath = payload;
    },
    updateDailyStatementParam(state, payload) {
      state.daily_statement = payload;
    },
    updateWinLoseParam(state, payload) {
      state.win_lose = payload;
    },
    updateWinLoseMemberParam(state, payload) {
      state.win_lose_member = payload;
    },
    updateDailySummaryCompanyParam(state, payload) {
      state.daily_summary_company = payload;
    },
    updateDailySummaryOperatorParam(state, payload) {
      state.daily_summary_operator = payload;
    },
    updateDailySummaryMemberParam(state, payload) {
      state.daily_summary_member = payload;
    },
    updateReportStatementParam(state, payload) {
      state.report_statement = payload;
    },
    updateGameResultParam(state, payload) {
      state.game_result = payload;
    },
    updateGameResultSlotsParam(state, payload) {
      state.game_result_slots = payload;
    },
    updateGameResultLivecasinoParam(state, payload) {
      state.game_result_livecasino = payload;
    },
    updateGameResultSportsbookParam(state, payload) {
      state.game_result_sportsbook = payload;
    },
    updateGameResultCockfightParam(state, payload) {
      state.game_result_cockfight = payload;
    },
    updateGameResultRescueParam(state, payload) {
      state.game_result_rescue = payload;
    },
    updateGameResultRewardParam(state, payload) {
      state.game_result_reward = payload;
    },
    updateGameResultFreeSlotsParam(state, payload) {
      state.game_result_free_slots = payload;
    },
    updateGameResultOthersParam(state, payload) {
      state.game_result_others = payload;
    },
    updateRebateMemberParam(state, payload) {
      state.rebate_member = payload
    },
    updateMemberLinkageParam(state, payload) {
      state.member_linkage = payload
    },
    updateBonusListParam(state, payload) {
      state.bonus_list = payload;
    },
    updateAdjustmentListParam(state, payload) {
      state.adjustment_list = payload;
    },
    updateAdjustmentLogParam(state, payload) {
      state.adjustment_log = payload;
    },
    updateBonusLogParam(state, payload) {
      state.bonus_log = payload;
    },
    updateLoginLogParam(state, payload) {
      state.login_log = payload;
    },
    updateResultChangesLogParam(state, payload) {
      state.result_changes_log = payload;
    },
    updateVipLogParam(state, payload) {
      state.vip_log = payload;
    },
    updateTokenLogParam(state, payload) {
      state.token_log = payload;
    },
    updateAdjustFreeBalanceLogParam(state, payload) {
      state.adjust_free_balance_log = payload;
    },
    updateMemberWalletVoucherLogParam(state, payload) {
      state.member_wallet_voucher_log = payload
    },
    updateMemberVoucherRedeemedLogParam(state, payload) {
      state.member_voucher_redeemed_log = payload;
    },
    updateMemberLogParam(state, payload) {
      state.member_log = payload;
    },
    updateFreeSpinLogParam(state, payload) {
      state.freespin_log = payload;
    },
    updateTransferListParam(state, payload) {
      state.transfer_list = payload;
    },
    updateBonusAndAdjustmentParam(state, payload) {
      state.bonus_and_adjustment = payload;
    },
    updateWinLoseAffParam(state, payload) {
      state.win_lose_aff = payload;
    },
    updateRefereeListParam(state, payload) {
      state.referee_list = payload;
    },
    updateWalletTransListListParam(state, payload) {
      state.ticket_wallet_trans_list = payload;
    },
    updateMemberDetailsParam(state, payload) {
      state.member_details = payload;
    },
    updatePendingTicketParam(state, payload) {
      state.pending_ticket = payload;
    },
    updateDailyWinLoseSBDetailParam(state, payload) {
      state.daily_winlose_sb_detail = payload;
    },
    updateDailyStatementAffParam(state, payload) {
      state.daily_statement_aff = payload;
    },
    updateAdjustmentListAffParam(state, payload) {
      state.adjustment_list_aff = payload;
    },
    updateDailySummaryCompanyDetailParam(state, payload) {
      state.daily_summary_company_detail = payload;
    },
    updateDailySummaryOperatorDetailParam(state, payload) {
      state.daily_summary_operator_detail = payload;
    },
    updateSelectedMemberID(state, payload) {
      state.selectedMemberID = payload;
    },
    updateSelectedOperatorID(state, payload) {
      state.selectedOperatorID = payload;
    },
    updateSelectedAffiliateID(state, payload) {
      state.selectedAffiliateID = payload;
    },
    updateSelectedSiteID(state, payload) {
      state.selectedSiteID = payload;
    },
    updateSelectedTheme(state, payload) {
      state.selectedTheme = payload;
    },
    updateSelectedNewWebsite(state, payload) {
      state.selectedNewWebsite = payload;
    },
    updateCurrencyCode(state, payload) {
      state.currencyCode = payload
    },
    updateCpiDetails(state, payload) {
      state.cpiDetails = payload
    },
    updateAuthOriginalChecked(state, payload) {
      state.authOriginalChecked = payload
    }
  },
  actions: {
    login(context, user) {
      const url = config.accountLoginUrl();
      const body = {
        login_id: user.username,
        password: user.password,
        domain_id: user.domain
      };

      const feedback = {
        redirect: "",
        success: false,
        status: errorTags.login.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("username" in user) || user.username.length <= 0) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("password" in user) || user.password.length <= 0) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("domain" in user) || user.domain.length <= 0) {
          feedback.status = errorTags.login.domainIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          var data = body;
          data = jwt.sign(body, config.AeRmWpXvLc);

          Vue.http.post(url, data).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;

                if (feedback.success == true) {

                  var sessionToken = null;
                  var authorityRole = null;
                  var profileStatus = null;
                  var securityDisabled = null;
                  var loginId = null;
                  var accountId = null;
                  var accountType = null;
                  var role = null;

                  try {
                    //new login
                    user.account = successResponse.body.value.account;
                    user.account_authority = successResponse.body.value.account_authority;

                    sessionToken = user.account[0].auth_token;
                    loginId = user.account[0].login_id;
                    authorityRole = user.account[0].authority_role;
                    accountId = user.account[0].account_id;
                    accountType = user.account[0].account_type;

                    if (user.account[0].auth_token) {
                      //new login
                      profileStatus = user.account[0].profile_status;
                      securityDisabled = user.account[0].security_disabled;

                      switch (profileStatus) {
                        //only operator will have NEW profile status
                        //master will be ACTIVE once created
                        case "NEW":
                          feedback.redirect = "/domainSetup";
                          break;
                        case "RESET":
                          // if (securityDisabled) {
                          //   feedback.redirect = "/resetPassword";
                          // } else {
                          //   feedback.redirect = "/security";
                          // }
                          feedback.redirect = "/resetPassword";
                          break;
                        case "ACTIVE":
                          // if (securityDisabled) {
                          //   if(accountType === 2) {
                          //     feedback.redirect = "/system/setting";
                          //   } else {
                          //     feedback.redirect = "/account/operator";
                          //   }
                          // } else {
                          //   feedback.redirect = "/security";
                          // }
                          if(authorityRole == "OWNER_PRI") {
                            var list = []
                            if(accountType === 2) {
                              list = authorityOpr.list
                              feedback.redirect = "/domain/domainList";
                            } else {
                              list = authority.list
                              feedback.redirect = "/account/operator";
                            }

                            const checkedItems = list
                              .filter(item => item.checked)
                              .map(item => ({
                                value: item.value,
                                checked: item.checked,
                                edit: item.edit
                              }));

                              context.commit("updateAuthOriginalChecked", checkedItems);
                          } else {
                            feedback.redirect = "/system/dashboard";
                          }
                          break;
                      }

                      context.commit("update", { sessionToken, authorityRole, loginId, user });

                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorTags.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    firstTime(context, user) {
      const url = config.addSecondaryUrl();
      const body = {
        login_id: this.state.user.loginId,
        new_login_id: user.new_username,
        new_password: user.new_password,
        security_tag: user.security_tag,
        security_code: user.security_code,
        audit_by: this.state.user.loginId,
        action_by: this.state.user.loginId,
        auth_token: this.state.user.sessionToken,
        account_id: this.state.user.accountId
      };
      const feedback = {
        redirect: "",
        success: false,
        status: errorTags.firstTime.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("new_username" in user)) {
          feedback.status = errorTags.firstTime.newUsernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.status = errorTags.firstTime.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_tag" in user)) {
          feedback.status = errorTags.firstTime.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_code" in user)) {
          feedback.status = errorTags.firstTime.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_username.length <= 0) {
          feedback.status = errorTags.firstTime.newUsernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.status = errorTags.firstTime.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_tag.length <= 0) {
          feedback.status = errorTags.firstTime.securityTagRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_code.length <= 0) {
          feedback.status = errorTags.firstTime.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.firstTime == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "firstTime", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {

                    feedback.redirect = "/security";
                    resolve(feedback);
                  } catch (error) {
                    //context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.firstTime.failed;
                    reject(feedback);
                  }
                } else {
                  // context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                //context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              //context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    security(context, user) {
      const url = config.securityValidateUrl();
      const body = {
        profile_id: user.profile_id,
        security_code: user.security_code,
        action_by: this.state.user.loginId,
        auth_token: this.state.user.sessionToken,
        account_id: this.state.user.accountId
      };
      const feedback = {
        redirect: "",
        success: false,
        status: errorTags.security.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("profile_id" in user)) {
          feedback.status = errorTags.security.profileIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("security_code" in user)) {
          feedback.status = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.profile_id.length <= 0) {
          feedback.status = errorTags.security.profileIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.security_code.length <= 0) {
          feedback.status = errorTags.security.securityCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.security == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "security", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "security", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    if (this.state.user.authorityRole && this.state.user.authorityRole == 'SUB_PRI') {
                      feedback.redirect = "/system/setting";
                    } else {
                      if (this.state.user.account[0] && this.state.user.accountId != config.superUser) {
                        feedback.redirect = "/account/memberList";
                      } else
                        feedback.redirect = "/account/operator";
                    }
                    resolve(feedback);
                  } catch (error) {
                    //context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.security.failed;
                    reject(feedback);
                  }
                } else {
                  // context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                //context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "firstTime", status: false });
              //context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePassword(context, user) {
      const url = config.passwordUpdateUrl();
      const body = {
        auth_token: this.state.user.sessionToken,
        action_by: this.state.user.loginId,
        login_id: this.state.user.loginId,
        profile_id: this.state.user.account[0].profile_id,
        password: user.password,
        new_password: user.new_password,
        account_id: this.state.user.accountId
      };
      const feedback = {
        success: false,
        status: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("password" in user)) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("new_password" in user)) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.password.length <= 0) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.new_password.length <= 0) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.updatePassword.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAgentDetail(context, user) {
      const url = config.accountAgentDetailUrl();
      const body = {
        auth_token: this.state.user.sessionToken,
        action_by: this.state.user.loginId,
        source_account_id: this.state.user.account[0].parent_id,
        target_account_id: this.state.user.accountId
      };
      const feedback = {
        success: false,
        status: errorTags.getAgentDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getAgentDetail == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getAgentDetail", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAgentDetail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.getAgentDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAgentDetail",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSubDetail(context, user) {
      const url = config.accountSubDetailUrl();
      const body = {
        auth_token: this.state.user.sessionToken,
        action_by: this.state.user.loginId,
        account_id: this.state.user.accountId,
        login_id: this.state.user.loginId
      };
      const feedback = {
        success: false,
        status: errorTags.getSubDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSubDetail == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getSubDetail", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSubDetail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    context.commit("updateAccountAuthorityOption", successResponse.body.dt[0].authority_option);
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.getSubDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSubDetail",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPGProviderBalance(context, user) {
      const url = config.pgProviderGetBalanceUrl();
      const body = {
        auth_token: this.state.user.sessionToken,
        action_by: this.state.user.loginId,
        account_id: this.state.user.accountId,
        pg: user.pg,
        external_id: user.external_id
      };
      const feedback = {
        success: false,
        status: errorTags.getSubDetail.failed,
        obj: null
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (this.state.user._loading.getSubDetail == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getSubDetail", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", {
              //   action: "getSubDetail",
              //   status: false
              // });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    if (successResponse.body.dt.length > 0)
                      feedback.obj = successResponse.body.dt[0]
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.getSubDetail.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", {
              //   action: "getSubDetail",
              //   status: false
              // });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    domainMemberSetup(context, user) {
      const url = config.domainMemberSetupUrl();
      const body = {
        action_by: this.state.user.loginId,
        auth_token: this.state.user.sessionToken,
        account_id: this.state.user.accountId,
        domain_name: user.domain_name
      };
      const feedback = {
        redirect: "",
        success: false,
        status: errorTags.domainSetup.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("domain_name" in user) || user.domain_name.length <= 0) {
          feedback.status = errorTags.domainSetup.domainNameRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.domainSetup == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "domainSetup", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "domainSetup", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // if (this.state.user.authorityRole && this.state.user.authorityRole == 'SUB_PRI') {
                    //   feedback.redirect = "/system/setting";
                    // } else {
                    //   if (this.state.user.account[0] && this.state.user.accountId != config.superUser) {
                    //     feedback.redirect = "/account/memberList";
                    //   } else
                    //     feedback.redirect = "/account/operator";
                    // }
                    resolve(feedback);
                  } catch (error) {
                    //context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.domainSetup.failed;
                    reject(feedback);
                  }
                } else {
                  // context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                //context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "domainSetup", status: false });
              //context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    setTACExpiry(context, payload){
      context.commit("updateTACExpiry", payload)
    },
    setGuide(context, payload) {
      context.commit("updateGuide", payload);
    },
    setAlertOn(context, payload) {
      context.commit("updateAlertOn", payload);
    },
    setSecurity(context, payload) {
      context.commit("updateSecurity", payload);
    },
    setAccountSetup(context, payload) {
      context.commit("updateAccountSetup", payload);
    },
    setAttachmentPath(context, payload) {
      context.commit("updateAttachmentPath", payload);
    },
    setDailyStatementParam(context, payload) {
      context.commit("updateDailyStatementParam", payload);
    },
    setWinLoseParam(context, payload) {
      context.commit("updateWinLoseParam", payload);
    },
    setWinLoseMemberParam(context, payload) {
      context.commit("updateWinLoseMemberParam", payload);
    },
    setDailySummaryCompanyParam(context, payload) {
      context.commit("updateDailySummaryCompanyParam", payload);
    },
    setDailySummaryOperatorParam(context, payload) {
      context.commit("updateDailySummaryOperatorParam", payload);
    },
    setDailySummaryMemberParam(context, payload) {
      context.commit("updateDailySummaryMemberParam", payload);
    },
    setReportStatementParam(context, payload) {
      context.commit("updateReportStatementParam", payload);
    },
    setGameResultParam(context, payload) {
      context.commit("updateGameResultParam", payload);
    },
    setGameResultSlotsParam(context, payload) {
      context.commit("updateGameResultSlotsParam", payload);
    },
    setGameResultLivecasinoParam(context, payload) {
      context.commit("updateGameResultLivecasinoParam", payload);
    },
    setGameResultSportsbookParam(context, payload) {
      context.commit("updateGameResultSportsbookParam", payload);
    },
    setGameResultCockfightParam(context, payload) {
      context.commit("updateGameResultCockfightParam", payload);
    },
    setGameResultRescueParam(context, payload) {
      context.commit("updateGameResultRescueParam", payload);
    },
    setGameResultRewardParam(context, payload) {
      context.commit("updateGameResultRewardParam", payload);
    },
    setGameResultFreeSlotsParam(context, payload) {
      context.commit("updateGameResultFreeSlotsParam", payload);
    },
    setGameResultOthersParam(context, payload) {
      context.commit("updateGameResultOthersParam", payload);
    },
    setRebateMemberParam(context, payload) {
      context.commit("updateRebateMemberParam", payload)
    },
    setMemberLinkageParam(context, payload) {
      context.commit("updateMemberLinkageParam", payload)
    },
    setBonusListParam(context, payload) {
      context.commit("updateBonusListParam", payload);
    },
    setAdjustmentListParam(context, payload) {
      context.commit("updateAdjustmentListParam", payload);
    },
    setAdjustmentLogParam(context, payload) {
      context.commit("updateAdjustmentLogParam", payload);
    },
    setBonusLogParam(context, payload) {
      context.commit("updateBonusLogParam", payload);
    },
    setLoginLogParam(context, payload) {
      context.commit("updateLoginLogParam", payload);
    },
    setResultChangesLogParam(context, payload) {
      context.commit("updateResultChangesLogParam", payload);
    },
    setVipLogParam(context, payload) {
      context.commit("updateVipLogParam", payload);
    },
    setTokenLogParam(context, payload) {
      context.commit("updateTokenLogParam", payload);
    },
    setAdjustFreeBalanceLogParam(context, payload) {
      context.commit("updateAdjustFreeBalanceLogParam", payload);
    },
    setMemberWalletVoucherLogParam(context, payload) {
      context.commit("updateMemberWalletVoucherLogParam", payload);
    },
    setMemberVoucherRedeemedLogParam(context, payload) {
      context.commit("updateMemberVoucherRedeemedLogParam", payload);
    },
    setMemberLogParam(context, payload) {
      context.commit("updateMemberLogParam", payload);
    },
    setFreeSpinLogParam(context, payload) {
      context.commit("updateFreeSpinLogParam", payload);
    },
    setTransferListParam(context, payload) {
      context.commit("updateTransferListParam", payload);
    },
    setBonusAndAdjustmentParam(context, payload) {
      context.commit("updateBonusAndAdjustmentParam", payload);
    },
    setWinLoseAffParam(context, payload) {
      context.commit("updateWinLoseAffParam", payload);
    },
    setRefereeListParam(context, payload) {
      context.commit("updateRefereeListParam", payload);
    },
    setTicketWalletTransListParam(context, payload) {
      context.commit("updateWalletTransListListParam", payload);
    },
    setMemberDetailsParam(context, payload) {
      context.commit("updateMemberDetailsParam", payload);
    },
    setPendingTicketParam(context, payload) {
      context.commit("updatePendingTicketParam", payload);
    },
    setDailyWinLoseSBDetailParam(context, payload) {
      context.commit("updateDailyWinLoseSBDetailParam", payload);
    },
    setDailyStatementAffParam(context, payload) {
      context.commit("updateDailyStatementAffParam", payload);
    },
    setAdjustmentListAffParam(context, payload) {
      context.commit("updateAdjustmentListAffParam", payload);
    },
    setDailySummaryCompanyDetailParam(context, payload) {
      context.commit("updateDailySummaryCompanyDetailParam", payload);
    },
    setDailySummaryOperatorDetailParam(context, payload) {
      context.commit("updateDailySummaryOperatorDetailParam", payload);
    },
    setSelectedMemberID(context, payload) {
      context.commit("updateSelectedMemberID", payload);
    },
    setSelectedOperatorID(context, payload) {
      context.commit("updateSelectedOperatorID", payload);
    },
    setSelectedAffiliateID(context, payload) {
      context.commit("updateSelectedAffiliateID", payload);
    },
    setSelectedSiteID(context, payload) {
      context.commit("updateSelectedSiteID", payload);
    },
    setSelectedTheme(context, payload) {
      context.commit("updateSelectedTheme", payload);
    },
    setSelectedNewWebsite(context, payload) {
      context.commit("updateSelectedNewWebsite", payload);
    },
    setCurrencyCode(context, payload) {
      context.commit("updateCurrencyCode", payload)
    },
    setCpiDetails(context, payload) {
      context.commit("updateCpiDetails", payload)
    },
    setAuthOriginalChecked(context, payload) {
      context.commit("updateAuthOriginalChecked", payload)
    }
  }
};
